import React from 'react';
import { BlockBarBase, BlockBarProps } from './BlockBarBase';

export function BlockBar(props: BlockBarProps) {
  return (
    <BlockBarBase {...props}>
      <div className="block-bar__button-container">{props.children}</div>
    </BlockBarBase>
  );
}
